const color = [
  "primary",
  "secondary",
  "success",
  "info",
  "warning",
  "error",
  "status-orange",
  "status-teal",
  "status-purple",
  "status-cyan",
  "status-sky",
  "status-indigo",
  "status-amber",
  "status-grey",
  "status-navy",
  "neutral"
] as const

const variant = [
  "solid",
  "outline",
  "soft",
  "subtle",
  "ghost",
  "link"
] as const

const size = [
  "xs",
  "sm",
  "md",
  "lg",
  "xl"
] as const

export default {
  "slots": {
    "base": [
      "rounded-md font-medium inline-flex items-center disabled:cursor-not-allowed aria-disabled:cursor-not-allowed disabled:opacity-75 aria-disabled:opacity-75",
      "transition-colors"
    ],
    "label": "truncate",
    "leadingIcon": "shrink-0",
    "leadingAvatar": "shrink-0",
    "leadingAvatarSize": "",
    "trailingIcon": "shrink-0"
  },
  "variants": {
    "fieldGroup": {
      "horizontal": "not-only:first:rounded-e-none not-only:last:rounded-s-none not-last:not-first:rounded-none focus-visible:z-[1]",
      "vertical": "not-only:first:rounded-b-none not-only:last:rounded-t-none not-last:not-first:rounded-none focus-visible:z-[1]"
    },
    "color": {
      "primary": "",
      "secondary": "",
      "success": "",
      "info": "",
      "warning": "",
      "error": "",
      "status-orange": "",
      "status-teal": "",
      "status-purple": "",
      "status-cyan": "",
      "status-sky": "",
      "status-indigo": "",
      "status-amber": "",
      "status-grey": "",
      "status-navy": "",
      "neutral": ""
    },
    "variant": {
      "solid": "",
      "outline": "",
      "soft": "",
      "subtle": "",
      "ghost": "",
      "link": ""
    },
    "size": {
      "xs": {
        "base": "px-2 py-1 text-xs gap-1",
        "leadingIcon": "size-4",
        "leadingAvatarSize": "3xs",
        "trailingIcon": "size-4"
      },
      "sm": {
        "base": "px-2.5 py-1.5 text-xs gap-1.5",
        "leadingIcon": "size-4",
        "leadingAvatarSize": "3xs",
        "trailingIcon": "size-4"
      },
      "md": {
        "base": "px-2.5 py-1.5 text-sm gap-1.5",
        "leadingIcon": "size-5",
        "leadingAvatarSize": "2xs",
        "trailingIcon": "size-5"
      },
      "lg": {
        "base": "px-3 py-2 text-sm gap-2",
        "leadingIcon": "size-5",
        "leadingAvatarSize": "2xs",
        "trailingIcon": "size-5"
      },
      "xl": {
        "base": "px-3 py-2 text-base gap-2",
        "leadingIcon": "size-6",
        "leadingAvatarSize": "xs",
        "trailingIcon": "size-6"
      }
    },
    "block": {
      "true": {
        "base": "w-full justify-center",
        "trailingIcon": "ms-auto"
      }
    },
    "square": {
      "true": ""
    },
    "leading": {
      "true": ""
    },
    "trailing": {
      "true": ""
    },
    "loading": {
      "true": ""
    },
    "active": {
      "true": {
        "base": ""
      },
      "false": {
        "base": ""
      }
    }
  },
  "compoundVariants": [
    {
      "color": "primary" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-primary hover:bg-primary/75 active:bg-primary/75 disabled:bg-primary aria-disabled:bg-primary outline-primary/25 focus-visible:outline-3"
    },
    {
      "color": "secondary" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-secondary hover:bg-secondary/75 active:bg-secondary/75 disabled:bg-secondary aria-disabled:bg-secondary outline-secondary/25 focus-visible:outline-3"
    },
    {
      "color": "success" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-success hover:bg-success/75 active:bg-success/75 disabled:bg-success aria-disabled:bg-success outline-success/25 focus-visible:outline-3"
    },
    {
      "color": "info" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-info hover:bg-info/75 active:bg-info/75 disabled:bg-info aria-disabled:bg-info outline-info/25 focus-visible:outline-3"
    },
    {
      "color": "warning" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-warning hover:bg-warning/75 active:bg-warning/75 disabled:bg-warning aria-disabled:bg-warning outline-warning/25 focus-visible:outline-3"
    },
    {
      "color": "error" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-error hover:bg-error/75 active:bg-error/75 disabled:bg-error aria-disabled:bg-error outline-error/25 focus-visible:outline-3"
    },
    {
      "color": "status-orange" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-status-orange hover:bg-status-orange/75 active:bg-status-orange/75 disabled:bg-status-orange aria-disabled:bg-status-orange outline-status-orange/25 focus-visible:outline-3"
    },
    {
      "color": "status-teal" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-status-teal hover:bg-status-teal/75 active:bg-status-teal/75 disabled:bg-status-teal aria-disabled:bg-status-teal outline-status-teal/25 focus-visible:outline-3"
    },
    {
      "color": "status-purple" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-status-purple hover:bg-status-purple/75 active:bg-status-purple/75 disabled:bg-status-purple aria-disabled:bg-status-purple outline-status-purple/25 focus-visible:outline-3"
    },
    {
      "color": "status-cyan" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-status-cyan hover:bg-status-cyan/75 active:bg-status-cyan/75 disabled:bg-status-cyan aria-disabled:bg-status-cyan outline-status-cyan/25 focus-visible:outline-3"
    },
    {
      "color": "status-sky" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-status-sky hover:bg-status-sky/75 active:bg-status-sky/75 disabled:bg-status-sky aria-disabled:bg-status-sky outline-status-sky/25 focus-visible:outline-3"
    },
    {
      "color": "status-indigo" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-status-indigo hover:bg-status-indigo/75 active:bg-status-indigo/75 disabled:bg-status-indigo aria-disabled:bg-status-indigo outline-status-indigo/25 focus-visible:outline-3"
    },
    {
      "color": "status-amber" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-status-amber hover:bg-status-amber/75 active:bg-status-amber/75 disabled:bg-status-amber aria-disabled:bg-status-amber outline-status-amber/25 focus-visible:outline-3"
    },
    {
      "color": "status-grey" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-status-grey hover:bg-status-grey/75 active:bg-status-grey/75 disabled:bg-status-grey aria-disabled:bg-status-grey outline-status-grey/25 focus-visible:outline-3"
    },
    {
      "color": "status-navy" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-status-navy hover:bg-status-navy/75 active:bg-status-navy/75 disabled:bg-status-navy aria-disabled:bg-status-navy outline-status-navy/25 focus-visible:outline-3"
    },
    {
      "color": "primary" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-primary/50 text-primary hover:bg-primary/10 active:bg-primary/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-primary/25 focus-visible:outline-3 focus-visible:ring-primary"
    },
    {
      "color": "secondary" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-secondary/50 text-secondary hover:bg-secondary/10 active:bg-secondary/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-secondary/25 focus-visible:outline-3 focus-visible:ring-secondary"
    },
    {
      "color": "success" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-success/50 text-success hover:bg-success/10 active:bg-success/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-success/25 focus-visible:outline-3 focus-visible:ring-success"
    },
    {
      "color": "info" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-info/50 text-info hover:bg-info/10 active:bg-info/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-info/25 focus-visible:outline-3 focus-visible:ring-info"
    },
    {
      "color": "warning" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-warning/50 text-warning hover:bg-warning/10 active:bg-warning/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-warning/25 focus-visible:outline-3 focus-visible:ring-warning"
    },
    {
      "color": "error" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-error/50 text-error hover:bg-error/10 active:bg-error/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-error/25 focus-visible:outline-3 focus-visible:ring-error"
    },
    {
      "color": "status-orange" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-status-orange/50 text-status-orange hover:bg-status-orange/10 active:bg-status-orange/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-status-orange/25 focus-visible:outline-3 focus-visible:ring-status-orange"
    },
    {
      "color": "status-teal" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-status-teal/50 text-status-teal hover:bg-status-teal/10 active:bg-status-teal/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-status-teal/25 focus-visible:outline-3 focus-visible:ring-status-teal"
    },
    {
      "color": "status-purple" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-status-purple/50 text-status-purple hover:bg-status-purple/10 active:bg-status-purple/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-status-purple/25 focus-visible:outline-3 focus-visible:ring-status-purple"
    },
    {
      "color": "status-cyan" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-status-cyan/50 text-status-cyan hover:bg-status-cyan/10 active:bg-status-cyan/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-status-cyan/25 focus-visible:outline-3 focus-visible:ring-status-cyan"
    },
    {
      "color": "status-sky" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-status-sky/50 text-status-sky hover:bg-status-sky/10 active:bg-status-sky/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-status-sky/25 focus-visible:outline-3 focus-visible:ring-status-sky"
    },
    {
      "color": "status-indigo" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-status-indigo/50 text-status-indigo hover:bg-status-indigo/10 active:bg-status-indigo/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-status-indigo/25 focus-visible:outline-3 focus-visible:ring-status-indigo"
    },
    {
      "color": "status-amber" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-status-amber/50 text-status-amber hover:bg-status-amber/10 active:bg-status-amber/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-status-amber/25 focus-visible:outline-3 focus-visible:ring-status-amber"
    },
    {
      "color": "status-grey" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-status-grey/50 text-status-grey hover:bg-status-grey/10 active:bg-status-grey/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-status-grey/25 focus-visible:outline-3 focus-visible:ring-status-grey"
    },
    {
      "color": "status-navy" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-status-navy/50 text-status-navy hover:bg-status-navy/10 active:bg-status-navy/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-status-navy/25 focus-visible:outline-3 focus-visible:ring-status-navy"
    },
    {
      "color": "primary" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-primary bg-primary/10 hover:bg-primary/15 active:bg-primary/15 outline-primary/25 focus-visible:outline-3 disabled:bg-primary/10 aria-disabled:bg-primary/10"
    },
    {
      "color": "secondary" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-secondary bg-secondary/10 hover:bg-secondary/15 active:bg-secondary/15 outline-secondary/25 focus-visible:outline-3 disabled:bg-secondary/10 aria-disabled:bg-secondary/10"
    },
    {
      "color": "success" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-success bg-success/10 hover:bg-success/15 active:bg-success/15 outline-success/25 focus-visible:outline-3 disabled:bg-success/10 aria-disabled:bg-success/10"
    },
    {
      "color": "info" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-info bg-info/10 hover:bg-info/15 active:bg-info/15 outline-info/25 focus-visible:outline-3 disabled:bg-info/10 aria-disabled:bg-info/10"
    },
    {
      "color": "warning" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-warning bg-warning/10 hover:bg-warning/15 active:bg-warning/15 outline-warning/25 focus-visible:outline-3 disabled:bg-warning/10 aria-disabled:bg-warning/10"
    },
    {
      "color": "error" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-error bg-error/10 hover:bg-error/15 active:bg-error/15 outline-error/25 focus-visible:outline-3 disabled:bg-error/10 aria-disabled:bg-error/10"
    },
    {
      "color": "status-orange" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-status-orange bg-status-orange/10 hover:bg-status-orange/15 active:bg-status-orange/15 outline-status-orange/25 focus-visible:outline-3 disabled:bg-status-orange/10 aria-disabled:bg-status-orange/10"
    },
    {
      "color": "status-teal" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-status-teal bg-status-teal/10 hover:bg-status-teal/15 active:bg-status-teal/15 outline-status-teal/25 focus-visible:outline-3 disabled:bg-status-teal/10 aria-disabled:bg-status-teal/10"
    },
    {
      "color": "status-purple" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-status-purple bg-status-purple/10 hover:bg-status-purple/15 active:bg-status-purple/15 outline-status-purple/25 focus-visible:outline-3 disabled:bg-status-purple/10 aria-disabled:bg-status-purple/10"
    },
    {
      "color": "status-cyan" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-status-cyan bg-status-cyan/10 hover:bg-status-cyan/15 active:bg-status-cyan/15 outline-status-cyan/25 focus-visible:outline-3 disabled:bg-status-cyan/10 aria-disabled:bg-status-cyan/10"
    },
    {
      "color": "status-sky" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-status-sky bg-status-sky/10 hover:bg-status-sky/15 active:bg-status-sky/15 outline-status-sky/25 focus-visible:outline-3 disabled:bg-status-sky/10 aria-disabled:bg-status-sky/10"
    },
    {
      "color": "status-indigo" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-status-indigo bg-status-indigo/10 hover:bg-status-indigo/15 active:bg-status-indigo/15 outline-status-indigo/25 focus-visible:outline-3 disabled:bg-status-indigo/10 aria-disabled:bg-status-indigo/10"
    },
    {
      "color": "status-amber" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-status-amber bg-status-amber/10 hover:bg-status-amber/15 active:bg-status-amber/15 outline-status-amber/25 focus-visible:outline-3 disabled:bg-status-amber/10 aria-disabled:bg-status-amber/10"
    },
    {
      "color": "status-grey" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-status-grey bg-status-grey/10 hover:bg-status-grey/15 active:bg-status-grey/15 outline-status-grey/25 focus-visible:outline-3 disabled:bg-status-grey/10 aria-disabled:bg-status-grey/10"
    },
    {
      "color": "status-navy" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-status-navy bg-status-navy/10 hover:bg-status-navy/15 active:bg-status-navy/15 outline-status-navy/25 focus-visible:outline-3 disabled:bg-status-navy/10 aria-disabled:bg-status-navy/10"
    },
    {
      "color": "primary" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-primary ring ring-inset ring-primary/25 bg-primary/10 hover:bg-primary/15 active:bg-primary/15 disabled:bg-primary/10 aria-disabled:bg-primary/10 outline-primary/25 focus-visible:outline-3 focus-visible:ring-primary"
    },
    {
      "color": "secondary" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-secondary ring ring-inset ring-secondary/25 bg-secondary/10 hover:bg-secondary/15 active:bg-secondary/15 disabled:bg-secondary/10 aria-disabled:bg-secondary/10 outline-secondary/25 focus-visible:outline-3 focus-visible:ring-secondary"
    },
    {
      "color": "success" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-success ring ring-inset ring-success/25 bg-success/10 hover:bg-success/15 active:bg-success/15 disabled:bg-success/10 aria-disabled:bg-success/10 outline-success/25 focus-visible:outline-3 focus-visible:ring-success"
    },
    {
      "color": "info" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-info ring ring-inset ring-info/25 bg-info/10 hover:bg-info/15 active:bg-info/15 disabled:bg-info/10 aria-disabled:bg-info/10 outline-info/25 focus-visible:outline-3 focus-visible:ring-info"
    },
    {
      "color": "warning" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-warning ring ring-inset ring-warning/25 bg-warning/10 hover:bg-warning/15 active:bg-warning/15 disabled:bg-warning/10 aria-disabled:bg-warning/10 outline-warning/25 focus-visible:outline-3 focus-visible:ring-warning"
    },
    {
      "color": "error" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-error ring ring-inset ring-error/25 bg-error/10 hover:bg-error/15 active:bg-error/15 disabled:bg-error/10 aria-disabled:bg-error/10 outline-error/25 focus-visible:outline-3 focus-visible:ring-error"
    },
    {
      "color": "status-orange" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-status-orange ring ring-inset ring-status-orange/25 bg-status-orange/10 hover:bg-status-orange/15 active:bg-status-orange/15 disabled:bg-status-orange/10 aria-disabled:bg-status-orange/10 outline-status-orange/25 focus-visible:outline-3 focus-visible:ring-status-orange"
    },
    {
      "color": "status-teal" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-status-teal ring ring-inset ring-status-teal/25 bg-status-teal/10 hover:bg-status-teal/15 active:bg-status-teal/15 disabled:bg-status-teal/10 aria-disabled:bg-status-teal/10 outline-status-teal/25 focus-visible:outline-3 focus-visible:ring-status-teal"
    },
    {
      "color": "status-purple" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-status-purple ring ring-inset ring-status-purple/25 bg-status-purple/10 hover:bg-status-purple/15 active:bg-status-purple/15 disabled:bg-status-purple/10 aria-disabled:bg-status-purple/10 outline-status-purple/25 focus-visible:outline-3 focus-visible:ring-status-purple"
    },
    {
      "color": "status-cyan" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-status-cyan ring ring-inset ring-status-cyan/25 bg-status-cyan/10 hover:bg-status-cyan/15 active:bg-status-cyan/15 disabled:bg-status-cyan/10 aria-disabled:bg-status-cyan/10 outline-status-cyan/25 focus-visible:outline-3 focus-visible:ring-status-cyan"
    },
    {
      "color": "status-sky" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-status-sky ring ring-inset ring-status-sky/25 bg-status-sky/10 hover:bg-status-sky/15 active:bg-status-sky/15 disabled:bg-status-sky/10 aria-disabled:bg-status-sky/10 outline-status-sky/25 focus-visible:outline-3 focus-visible:ring-status-sky"
    },
    {
      "color": "status-indigo" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-status-indigo ring ring-inset ring-status-indigo/25 bg-status-indigo/10 hover:bg-status-indigo/15 active:bg-status-indigo/15 disabled:bg-status-indigo/10 aria-disabled:bg-status-indigo/10 outline-status-indigo/25 focus-visible:outline-3 focus-visible:ring-status-indigo"
    },
    {
      "color": "status-amber" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-status-amber ring ring-inset ring-status-amber/25 bg-status-amber/10 hover:bg-status-amber/15 active:bg-status-amber/15 disabled:bg-status-amber/10 aria-disabled:bg-status-amber/10 outline-status-amber/25 focus-visible:outline-3 focus-visible:ring-status-amber"
    },
    {
      "color": "status-grey" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-status-grey ring ring-inset ring-status-grey/25 bg-status-grey/10 hover:bg-status-grey/15 active:bg-status-grey/15 disabled:bg-status-grey/10 aria-disabled:bg-status-grey/10 outline-status-grey/25 focus-visible:outline-3 focus-visible:ring-status-grey"
    },
    {
      "color": "status-navy" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-status-navy ring ring-inset ring-status-navy/25 bg-status-navy/10 hover:bg-status-navy/15 active:bg-status-navy/15 disabled:bg-status-navy/10 aria-disabled:bg-status-navy/10 outline-status-navy/25 focus-visible:outline-3 focus-visible:ring-status-navy"
    },
    {
      "color": "primary" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-primary hover:bg-primary/10 active:bg-primary/10 outline-primary/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
    },
    {
      "color": "secondary" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-secondary hover:bg-secondary/10 active:bg-secondary/10 outline-secondary/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
    },
    {
      "color": "success" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-success hover:bg-success/10 active:bg-success/10 outline-success/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
    },
    {
      "color": "info" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-info hover:bg-info/10 active:bg-info/10 outline-info/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
    },
    {
      "color": "warning" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-warning hover:bg-warning/10 active:bg-warning/10 outline-warning/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
    },
    {
      "color": "error" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-error hover:bg-error/10 active:bg-error/10 outline-error/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
    },
    {
      "color": "status-orange" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-status-orange hover:bg-status-orange/10 active:bg-status-orange/10 outline-status-orange/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
    },
    {
      "color": "status-teal" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-status-teal hover:bg-status-teal/10 active:bg-status-teal/10 outline-status-teal/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
    },
    {
      "color": "status-purple" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-status-purple hover:bg-status-purple/10 active:bg-status-purple/10 outline-status-purple/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
    },
    {
      "color": "status-cyan" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-status-cyan hover:bg-status-cyan/10 active:bg-status-cyan/10 outline-status-cyan/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
    },
    {
      "color": "status-sky" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-status-sky hover:bg-status-sky/10 active:bg-status-sky/10 outline-status-sky/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
    },
    {
      "color": "status-indigo" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-status-indigo hover:bg-status-indigo/10 active:bg-status-indigo/10 outline-status-indigo/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
    },
    {
      "color": "status-amber" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-status-amber hover:bg-status-amber/10 active:bg-status-amber/10 outline-status-amber/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
    },
    {
      "color": "status-grey" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-status-grey hover:bg-status-grey/10 active:bg-status-grey/10 outline-status-grey/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
    },
    {
      "color": "status-navy" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-status-navy hover:bg-status-navy/10 active:bg-status-navy/10 outline-status-navy/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
    },
    {
      "color": "primary" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-primary hover:text-primary/75 active:text-primary/75 disabled:text-primary aria-disabled:text-primary outline-primary/25 focus-visible:outline-3"
    },
    {
      "color": "secondary" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-secondary hover:text-secondary/75 active:text-secondary/75 disabled:text-secondary aria-disabled:text-secondary outline-secondary/25 focus-visible:outline-3"
    },
    {
      "color": "success" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-success hover:text-success/75 active:text-success/75 disabled:text-success aria-disabled:text-success outline-success/25 focus-visible:outline-3"
    },
    {
      "color": "info" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-info hover:text-info/75 active:text-info/75 disabled:text-info aria-disabled:text-info outline-info/25 focus-visible:outline-3"
    },
    {
      "color": "warning" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-warning hover:text-warning/75 active:text-warning/75 disabled:text-warning aria-disabled:text-warning outline-warning/25 focus-visible:outline-3"
    },
    {
      "color": "error" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-error hover:text-error/75 active:text-error/75 disabled:text-error aria-disabled:text-error outline-error/25 focus-visible:outline-3"
    },
    {
      "color": "status-orange" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-status-orange hover:text-status-orange/75 active:text-status-orange/75 disabled:text-status-orange aria-disabled:text-status-orange outline-status-orange/25 focus-visible:outline-3"
    },
    {
      "color": "status-teal" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-status-teal hover:text-status-teal/75 active:text-status-teal/75 disabled:text-status-teal aria-disabled:text-status-teal outline-status-teal/25 focus-visible:outline-3"
    },
    {
      "color": "status-purple" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-status-purple hover:text-status-purple/75 active:text-status-purple/75 disabled:text-status-purple aria-disabled:text-status-purple outline-status-purple/25 focus-visible:outline-3"
    },
    {
      "color": "status-cyan" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-status-cyan hover:text-status-cyan/75 active:text-status-cyan/75 disabled:text-status-cyan aria-disabled:text-status-cyan outline-status-cyan/25 focus-visible:outline-3"
    },
    {
      "color": "status-sky" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-status-sky hover:text-status-sky/75 active:text-status-sky/75 disabled:text-status-sky aria-disabled:text-status-sky outline-status-sky/25 focus-visible:outline-3"
    },
    {
      "color": "status-indigo" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-status-indigo hover:text-status-indigo/75 active:text-status-indigo/75 disabled:text-status-indigo aria-disabled:text-status-indigo outline-status-indigo/25 focus-visible:outline-3"
    },
    {
      "color": "status-amber" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-status-amber hover:text-status-amber/75 active:text-status-amber/75 disabled:text-status-amber aria-disabled:text-status-amber outline-status-amber/25 focus-visible:outline-3"
    },
    {
      "color": "status-grey" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-status-grey hover:text-status-grey/75 active:text-status-grey/75 disabled:text-status-grey aria-disabled:text-status-grey outline-status-grey/25 focus-visible:outline-3"
    },
    {
      "color": "status-navy" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-status-navy hover:text-status-navy/75 active:text-status-navy/75 disabled:text-status-navy aria-disabled:text-status-navy outline-status-navy/25 focus-visible:outline-3"
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-inverted hover:bg-inverted/90 active:bg-inverted/90 disabled:bg-inverted aria-disabled:bg-inverted outline-inverted/25 focus-visible:outline-3"
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-accented text-default bg-default hover:bg-elevated active:bg-elevated disabled:bg-default aria-disabled:bg-default outline-inverted/25 focus-visible:outline-3 focus-visible:ring-inverted"
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-default bg-elevated hover:bg-accented/75 active:bg-accented/75 outline-inverted/25 focus-visible:outline-3 disabled:bg-elevated aria-disabled:bg-elevated"
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "ring ring-inset ring-accented text-default bg-elevated hover:bg-accented/75 active:bg-accented/75 disabled:bg-elevated aria-disabled:bg-elevated outline-inverted/25 focus-visible:outline-3 focus-visible:ring-inverted"
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-default hover:bg-elevated active:bg-elevated outline-inverted/25 focus-visible:outline-3 hover:disabled:bg-transparent dark:hover:disabled:bg-transparent hover:aria-disabled:bg-transparent dark:hover:aria-disabled:bg-transparent"
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-muted hover:text-default active:text-default disabled:text-muted aria-disabled:text-muted outline-inverted/25 focus-visible:outline-3"
    },
    {
      "size": "xs" as typeof size[number],
      "square": true,
      "class": "p-1"
    },
    {
      "size": "sm" as typeof size[number],
      "square": true,
      "class": "p-1.5"
    },
    {
      "size": "md" as typeof size[number],
      "square": true,
      "class": "p-1.5"
    },
    {
      "size": "lg" as typeof size[number],
      "square": true,
      "class": "p-2"
    },
    {
      "size": "xl" as typeof size[number],
      "square": true,
      "class": "p-2"
    },
    {
      "loading": true,
      "leading": true,
      "class": {
        "leadingIcon": "animate-spin"
      }
    },
    {
      "loading": true,
      "leading": false,
      "trailing": true,
      "class": {
        "trailingIcon": "animate-spin"
      }
    }
  ],
  "defaultVariants": {
    "color": "primary" as typeof color[number],
    "variant": "solid" as typeof variant[number],
    "size": "md" as typeof size[number]
  }
}